var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-4 reports-tab-container" }, [
      _c("div", { staticClass: "row report-fields-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(_vm._s(_vm.$tc("data_exports.payments.user"))),
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                options: _vm.users,
                "group-select": false,
                searchable: true,
                "show-labels": false,
                placeholder: _vm.$t("general.select_a_user"),
                "group-values": "options",
                "group-label": "label",
                "track-by": "id",
                label: "name",
              },
              on: { select: _vm.onSelectBuyer, input: _vm.onChangeBuyer },
              model: {
                value: _vm.formData.company_id,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "company_id", $$v)
                },
                expression: "formData.company_id",
              },
            }),
            _vm._v(" "),
            _vm.$v.formData.company_id.$error &&
            !_vm.$v.formData.company_id.required
              ? _c("span", { staticClass: "text-danger" }, [
                  _vm._v(" " + _vm._s(_vm.$t("validation.required")) + " "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6 report-field-container" },
          [
            _c("label", { staticClass: "report-label" }, [
              _vm._v(_vm._s(_vm.$t("reports.invoices.invoice_list"))),
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                options: _vm.buyerInvoicesList,
                "group-select": false,
                searchable: true,
                "show-labels": false,
                placeholder: _vm.$t("invoices.select_invoice"),
                "group-values": "options",
                "group-label": "label",
                "track-by": "id",
                label: "name",
              },
              on: { input: _vm.onChangeInvoice },
              model: {
                value: _vm.formData.invoice_id,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "invoice_id", $$v)
                },
                expression: "formData.invoice_id",
              },
            }),
            _vm._v(" "),
            _vm.$v.formData.invoice_id.$error &&
            !_vm.$v.formData.invoice_id.required
              ? _c("span", { staticClass: "text-danger" }, [
                  _vm._v(" " + _vm._s(_vm.$t("validation.required")) + " "),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row report-submit-button-container" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c(
              "base-button",
              {
                staticClass: "report-button",
                attrs: { outline: "", color: "theme" },
                on: {
                  click: function ($event) {
                    return _vm.getReports()
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("reports.update_report")) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-sm-8 reports-tab-container" }, [
      _c("iframe", {
        staticClass: "reports-frame-style",
        attrs: { src: _vm.getReportUrl },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "base-button btn btn-primary btn-lg report-view-button",
          on: { click: _vm.viewReportsPDF },
        },
        [
          _c("font-awesome-icon", {
            staticClass:
              "vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2",
            attrs: { icon: "file-pdf" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("reports.view_pdf")))]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }